module.exports = __webpack_public_path__ + "static/img/badge_sa.cd04357.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/badges/badge_sa.svg
// module id = 2673
// module chunks = 0